<template>
  <div class="home">
    <div class="top">
      <div class="banner">
        <div class="banner-text">
          <h1>水质荧光指纹污染溯源平台</h1>
          <div class="english-text">
            Aqueous Fluorescence Fingerprint Pollution Tracing Platform
          </div>
          <div class="js-text">
            应⽤深度学习技术+⽔质荧光指纹，智能辨别⼯业企业、城镇污⽔处理⼚、⽣活污⽔、畜禽养殖、⽔产养殖或常⻅城镇⾬洪等不同类型排⽔；提供平台建⽴⾃有污染源的⽔质荧光指纹数据库
          </div>
        </div>
      </div>

      <!-- 公告 -->
      <div class="message-wrap">
        <div class="wid-1400">
          <div class="messgae-box">
            <div class="icon">
              <i class="iconfont icon-laba"></i>
            </div>
            <div class="message">
              <p>
                <el-carousel
                  height="22px"
                  direction="vertical"
                  :autoplay="true"
                  indicator-position="none"
                  @change="changeCarousel"
                >
                  <el-carousel-item v-for="item in messageData" :key="item.id">
                    <span @click="showData(item)">{{ item.title }}</span>
                  </el-carousel-item>
                </el-carousel>
              </p>
            </div>
            <div class="button">
              <!-- <router-link :to="'/notice?id=' + messageData[index].id"><span>查看更多</span></router-link> -->
              <span @click="showMore">查看更多</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 介绍 -->
      <div class="introduce-wrap">
        <div class="wid-1200">
          <div class="introduce-box">
            <!-- <div class="line"></div> -->
            <div class="items">
              <div class="item-left">
                <div class="title">
                  <div class="title-text">
                    <div class="cn">构建自有荧光指纹数据库</div>
                    <div class="en">Build your own fluorescence fingerprint database</div>
                  </div>
                </div>
                <div class="text">
                  <div class="text-data">
                    <strong>一、公共数据:</strong><span> 为实现光谱数据共享，平台提供水质荧光指纹公共数据库供所有用户进行对比分析</span><br/>
                    <strong>二、私有数据:</strong><span> 注册用户默认可构建5个自有荧光指纹数据库，每个数据库可录入100条私有数据，用于自己对比分析</span><br/>
                    <strong>三、发布共享:</strong><span> 注册用户可将私有数据发布到公共数据库，实现数据共享，发布的数据不受100条的数量限制</span>
                  </div>
                </div>
                <div class="click-in-button" @click="openMyDatabase">
                  进入平台
                </div>
              </div>
              <div class="item-right">
                <div class="title">
                  <div class="title-text">
                    <div class="cn">荧光指纹污染溯源</div>
                    <div class="en">Fluorescence fingerprint pollution source tracing</div>
                  </div>
                </div>
                <div class="text">
                  <div class="text-data">
                    <strong>一、数据库对⽐分析:</strong><span> 本站基础数据库已收录常⻅污染源类型⽔质荧光指纹，可将未 知⽔质荧光指纹与基础数据库或⾃建数据库进⾏⽐对溯源</span><br/>
                    <strong>二、相似度计算分析:</strong><span> 提供多种智能算法进⾏⽔质荧光指纹相似度计算</span><br/>
                    <strong>三、荧光指纹溯源分析:</strong><span> 应⽤深度学习技术智能识别⽔质荧光指纹，给出可能污染来源和组成占⽐等</span>
                  </div>
                </div>
                <div class="click-in-button" @click="openSelectscipt">
                  进入平台
                </div>
              </div>
              <!-- <el-row :gutter="20">
                <el-col :span="12"
                  >
                  <div class="item" @click="openMyDatabase">
                      <div class="icon">
                        <i class="iconfont icon-shujuku"></i>
                      </div>
                      <h3>构建自有荧光指纹数据库</h3>
                      <p>
                         注册用户可构建自有荧光指纹数据库，并应用于荧光指纹污染溯源分析中
                      </p>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="item" @click="openSelectscipt">
                    <div class="icon">
                      <i class="iconfont icon-kehujiaobenduan"></i>
                    </div>
                    <h3>荧光指纹污染溯源</h3>
                    <p>
                      <span>1、数据库对比分析：本站基础数据库已收录常见污染源类型水质荧光指纹，可将未
                        知水质荧光指纹与基础数据库或自建数据库进行对比溯源</span>
                      <span>2、相似度计算分析：提供多种智能算法进行水质荧光指纹相似度计算</span>
                      <span>3、应该指纹溯源分析：应用深度学习技术智能识别水质荧光指纹，给出可能污染来源和组成占比等</span>
                    </p>
                  </div>
                </el-col>
                
              </el-row> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <FooterVue @openMessageBoxWrap="openMessageBoxWrap" :color="'#fff'" :color2="'#69FFF8'" @loginOut="loginOut" :loginData="loginData" @openLogin="openLogin" @openRegister="openRegister" :login="login"></FooterVue>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import notice from "@/api/notice";
import FooterVue from "@/components/Footer/Footer.vue";
export default {
  name: "HomeView",
  components: {
    FooterVue,
  },
  data() {
    return {
      searchInput: "",
      messageData: [],
      index: 0,
    };
  },
  props: {
    loginData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    login: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    openMessageBoxWrap(item) {
      this.$emit("openMessageBoxWrap",item);
    },
    openRegister() {
      this.$emit("openRegister");
    },
    openLogin() {
      this.$emit("openLogin");
    },
    loginOut(){
      this.$emit("loginOut"); 
    },
    openSelectscipt() {
      if (sessionStorage.getItem("login") === "true") {
        this.$router.push({
          path: "/selectscipt",
        });
      } else {
        this.$emit("goLogin");
      }
    },
    openMyDatabase() {
      if (sessionStorage.getItem("login") === "true") {
        this.$router.push({
          path: "/mydatabase",
        });
      } else {
        this.$emit("goLogin");
      }
    },
    getNoticeList() {
      notice
        .noticeList()
        .then((res) => {
          if (res.code === 0) {
            this.messageData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeCarousel(data) {
      this.index = data;
    },
    showMore() {
      this.$router.push({
        path: "/noticeAll",
      });
    },
    showData(item) {
      if(item.webUrl&&item.noticeType===2) {
        window.open(item.webUrl)
      } else {
        this.$router.push({
          path: "/notice?id=" + item.id,
        });
      }
    },
    searchSubmit() {
      if (sessionStorage.getItem("login") === "true") {
        if (this.searchInput) {
          this.$router.push({
            name: "search",
            params: {
              name: this.searchInput,
            },
          });
        } else {
          this.$message({
            message: "请输入要搜索的内容",
            type: "warning",
          });
        }
      } else {
        this.$emit("goLogin");
      }
    },
  },
  created() {
    this.getNoticeList();
  },
};
</script>

<style scoped lang="scss">

.home {
 
  height: 100%;
  background: url('./../assets/img/back2.png') no-repeat;
  background-position: left bottom;
  background-size: 100%;
  .top {
    height: calc(100% - 46px);
  }
  .footer {
    height: 46px;
    background-image: linear-gradient(to top, #054A75, rgba(#0F6CC3, 0));
  }
  .banner {
    background-image: url("./../assets/img/banner.png");
    background-size: 100% 100%;
    background-position: 0 0;

    padding-top: 50px;
    padding-bottom: 50px;
    height: 269px;
    position: relative;

    &::after {
      content: " ";
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-image: linear-gradient(to right, #395dc2, rgba(#0f7cca, 0));
      z-index: 1;
    }

    .banner-text {
      text-align: left;
      color: #fff;
      position: absolute;
      z-index: 2;
      padding-left: 36px;
      width: 50%;
      left: 0;
      top: 50%;
      transform: translateY(-50%);

      h1 {
        font-size: 35px;
        margin-bottom: 10px;
      }

      .english-text {
        font-size: 14px;
        margin-bottom: 10px;
        &::first-letter {
          text-transform: uppercase;
        }
      }

      .js-text {
        font-size: 14px;
        max-width: 610px;
      }
    }
  }

  .message-wrap {
    height: 37px;
    background: rgba(204, 224, 255, 1);
    .messgae-box {
      height: 37px;
      display: flex;
      align-items: center;
      width: 100%;
      .icon {
        width: 30px;
        text-align: center;
        i {
          color: #0366f1;
        }
      }

      .message {
        flex: 1;

        span {
          cursor: pointer;
          &:hover {
            color: #00a8ff;
            transition: all 0.6s;
          }
        }
      }

      .button {
        width: 100px;

        span {
          display: inline-block;
          text-align: center;
          width: 72px;
          height: 24px;
          line-height: 24px;
          background-color: #0366f1;
          color: #fff;
          border-radius: 5px;
          cursor: pointer;
          -webkit-user-select: none; /* Safari */
          -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* IE10+/Edge */
          user-select: none; /* 标准语法 */
          &:hover {
            background-color: rgba($color: #00a8ff, $alpha: 0.7);
            transition: all 0.6s;
          }

          &:active {
            scale: 0.9;
            background-color: rgba($color: #00a8ff, $alpha: 1);
          }
        }
      }
    }
  }

  .search-wrap {
    padding: 40px 0;

    .search-box {
      display: flex;
      width: 100%;
      border: 1px solid rgba(0, 0, 0, 0.2);

      .search-button {
        width: 146px;
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #00a8ff;
        color: #fff;
        cursor: pointer;
        user-select: none;
        border: 1px solid #00a8ff;

        &:hover {
          i {
            scale: 1.1;
          }
        }
        &:active {
          i {
            scale: 1;
          }
        }
      }

      .search-input {
        flex: 1;
        height: 44px;
        input {
          width: 100%;
          height: 100%;
          border: none;
          padding-left: 20px;
          outline: none;
          &:focus {
            box-shadow: 0 0 0 2px #00a8ff;
          }
        }
      }
    }
  }

  .introduce-wrap {
    .introduce-box {
      .items {
        &::after {
          content: " ";
          clear: both;
          display: block;
        }
        // display: grid;
        .el-col-12 {
          height: 100%;
        }
        .item {
          padding: 10px;
          cursor: pointer;
          border-radius: 10px;
          height: 100%;
          &:hover {
            background: rgba(0, 0, 0, 0.1);
            transition: all 0.5s;
          }
          h3 {
            text-align: center;
          }
          p {
            // height: 64px;
            //margin-top: 20px;
            text-align: center;
            color: #000;
            // max-width: 320px;
            margin: 20px 0px 10px 0px;
            span {
              display: block;
              text-align: left;
            }
          }

          .icon {
            text-align: center;
            margin-bottom: 20px;

            i {
              font-size: 70px;
              color: #000;
            }
          }
        }

        .item-left,
        .item-right {
          width: 576px;
          height: 309px;
          background: url("./../assets/img/box01.png") no-repeat 100% 100%;
          margin-top: 48px;
          max-width: 100%;
          position: relative;

          .click-in-button {
            width: 88px;
            height: 32px;
            text-align: center;
            line-height: 32px;
            color: #fff;
            background-image: linear-gradient(to right, #FF7023, #FF952A);
            position: absolute;
            right: 10px;
            bottom: 10px;
            border-radius: 16px;
            cursor: pointer;
            &:hover {
              background-image: linear-gradient(to right, #FF7023, #FF7023);
              transition: all 0.6s;
            }
            &:active {
              background-image: linear-gradient(to right, #FF952A, #FF952A);
              transition: all 0.6s;
            }
          }

          .title {
            height: 121px;
            color: #fff;
            display: flex;
            align-items: center;
            padding-left: 14px;
            .title-text {
              .cn {
                font-size: 23px;
              }
              .en {
                font-size: 11px;
              }
            }
          }
          .text {
            height: 188px;
            background: #fff;
            border-radius: 24px;
            padding: 16px;
            line-height: 24px;
          }
        }

        .item-left {
          float: left;
        }
        .item-right {
          float: right;
        }
      }
    }
  }
}

@media screen and (max-width: 1550px) {
  .home {
    height: auto;
  }
}
</style>
